<app-account-form [user]="user" [totpSecret]="totpSecret$ | async" [isTotpEnabled]="isTotpEnabled$ | async"
    (detailsEdit)="onDetailsEdit($event)" (passwordEdit)="onPasswordEdit($event)" (verifyTotp)="onVerifyTotp($event)"
    (disableTotp)="onDisableTotp()">
</app-account-form>